const LamdaURL =
  "https://eayesxbydzmitixlmlbkmspix40vihzp.lambda-url.ap-south-1.on.aws/";

export async function deleteUserFolder(username) {
  const response = await fetch(LamdaURL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username }),
  });

  if (!response.ok) {
    throw new Error("Failed to delete old files");
  }

  return response.json();
}
